import toast from "react-hot-toast";
import type {
  FinanceLogisticsOrder,
  FinanceMetaCampaignPerformance,
} from "../../services/financeService";

const csvEscape = (value: unknown) => {
  const raw = value === null || value === undefined ? "" : String(value);
  return `"${raw.replace(/"/g, '""')}"`;
};

export const downloadCsv = (filename: string, rows: Array<Record<string, unknown>>) => {
  if (rows.length === 0) {
    toast("No hay datos para descargar");
    return;
  }

  const headers = Object.keys(rows[0]);
  const content = [
    headers.map(csvEscape).join(","),
    ...rows.map((row) => headers.map((header) => csvEscape(row[header])).join(",")),
  ].join("\n");

  const blob = new Blob([`\uFEFF${content}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

export const orderCsvRows = (orders: FinanceLogisticsOrder[]) =>
  orders.map((order) => ({
    orden: order.order_hash_id || order.order_id,
    dropi_order_id: order.dropi_order_id ?? "",
    canal: order.funnel_id ? "Fluxi" : "Otros canales",
    funnel_id: order.funnel_id ?? "",
    estado: order.status_label,
    ciudad: order.city ?? "",
    departamento: order.department ?? "",
    transportadora: order.carrier ?? "",
    guia: order.guide_number ?? "",
    producto: order.product_names ?? "",
    unidades: order.units,
    venta: order.value,
    costo_producto: order.product_cost ?? 0,
    flete_envio: order.shipping_cost ?? 0,
    costo_variable: order.variable_cost ?? 0,
    moneda: order.currency,
    fecha: order.created_at,
  }));

export const campaignCsvRows = (
  campaigns: FinanceMetaCampaignPerformance[],
  funnelNameByCampaignId?: Map<string, string>
) =>
  campaigns.map((campaign) => ({
    campaign_id: campaign.id,
    campana: campaign.name,
    cuenta_publicitaria: campaign.ad_account_id ?? "",
    estado: campaign.effective_status ?? "",
    embudo: funnelNameByCampaignId?.get(campaign.id) ?? "",
    embudos_fluxi: campaign.matched_funnel_ids.join(" | "),
    pauta: campaign.spend,
    clics: campaign.clicks,
    compras_meta: campaign.purchases,
    ingresos_meta: campaign.purchase_value,
    roas_meta: campaign.roas,
  }));
